<template>

  <div class="wrap">
    <!-- 导航 -->
    <div class="page-header">
      <Nav :activeId="activeId" />
    </div>

    <div class="section-one self-bg">
      <div class="nav-bar nav-bar-black">
        <!-- <div class="nav-bar_label">Explore Bänninger</div> -->
        <div class="nav-bar_label">Conex Bänninger Discovery</div>
        <div class="nav-bar_bread">
          <a href="/home">首页</a><span>探索班尼戈</span><span>优秀案例</span>中国案例
        </div>
      </div>
      <!-- <div class="nav-bar">
        <img src="../../img/case/china/nav-top.png" class="product china-case" />
      </div> -->

      <div class="sub-title">
        <img src="../../img/case/china/sub-title-1.png" />
      </div>
      <div class="case-list">
        <img src="../../img/case/china/item1/1.jpg" />
        <img src="../../img/case/china/item1/2.jpg" />
        <img src="../../img/case/china/item1/3.jpg" />
        <img src="../../img/case/china/item1/4.jpg" />
        <img src="../../img/case/china/item1/5.jpg" />
      </div>

      <div class="sub-title">
        <img src="../../img/case/china/sub-title-2.png" />
      </div>
      <div class="case-list">
        <img src="../../img/case/china/item2/1.jpg" />
        <img src="../../img/case/china/item2/2.jpg" />
        <img src="../../img/case/china/item2/3.jpg" />
        <img src="../../img/case/china/item2/4.jpg" />
        <img src="../../img/case/china/item2/5.jpg" />
        <img src="../../img/case/china/item2/6.jpg" />
      </div>

    </div>

    <!-- 尾部 -->
    <Footer />
  </div>

</template>

<script>
// import $ from 'jquery'
import 'swiper/dist/js/swiper'
import 'swiper/dist/css/swiper.css'
import Swiper from "swiper"
import Nav from '../components/Nav.vue'
import Footer from '../components/Footer.vue'
export default {
  data() {
    return {
      
    }
  },
  components: {
    Nav,
    Footer
  },
  mounted() {
    new Swiper(".swiper-container", {
      slidesPerView: 1,
      spaceBetween: 0,
      centeredSlides: true,
      loop: true,
      // slideToClickedSlide: true, // 放开后，可以点击任意swiper，会立马将点击的swiper居中并展示相应内容（有个坑，自己摸索，这也是我不放开的原因）
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
        hideOnClick: true
      },
      on: {
        slideChange: function() {
          console.log(this.realIndex, 'realIndex', this)
        }
      }
    })
  },
  methods: {
    changeSwipe(type) {
      if(type == 'up') {
        this.index -= 1;
      } else if (type == 'down') {
        this.index += 1;
      }
      // this.$refs.swiper.swipeTo(this.index);
      this.$refs.swiper.swipeTo(this.activeIndex+1);
    },
    onChange (index) {
      console.log(index)
      this.activeIndex = index
    },
    goPrev() {
      this.$refs.swiper.prev();
    },
    goNext() {
      this.$refs.swiper.next();
    }
  }
};
</script>

<style scoped lang="less">
.self-bg {
  min-height: 500px;
  // padding: 30px 0;
  background-color: #EFEFEF;
  overflow: auto;
  padding: 100px 0 200px;
}
.sub-title {
  width: 1100px;
  margin: 100px auto 60px;
  img {
    width: 100%;
    height: auto;
  }
}
.case-list {
  width: 1100px;
  // height: 1500px;
  margin: 0 auto;
  // position: absolute;
  // top: 200px;
  // left: 0;
  // right: 0;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  img {
      width: 1100px;
      height: 310px;
      margin-bottom: 30px;
  }
}
</style>